import { ICategory, ITerm } from "@evennt-tech/api-v2-core";

/*
 * FS-2890's wire contract now ships in `@evennt-tech/api-v2-external`, so this
 * file is a re-export rather than a second declaration of the same shapes: one
 * import site for the whole feature, and the SDK stays the single source of
 * truth for what the endpoints return.
 *
 * What remains local are the two link predicates below. They are console
 * vocabulary, not wire types — the API answers with `masterTermId`, and "is this
 * row linked?" is the question every card, badge and menu actually asks.
 */
export type {
  IArchiveMasterCategoryRes,
  IArchiveMasterSectionRes,
  IAssignShowInfoToShowsRes,
  ICreateMasterCategoryRes,
  ICreateMasterSectionRes,
  IEditMasterCategoryRes,
  IEditMasterSectionRes,
  IGetManyShowInfoLibraryRes,
  IGetShowInfoLibraryMatchesRes,
  IImportShowInfoFromLibraryRes,
  ILibraryCategory,
  ILibrarySection,
  ILibrarySectionMatch,
  IPushShowInfoToLibraryReq,
  IPushShowInfoToLibraryRes,
  IRemoveMasterShowInfoConflict,
  IShowInfoImportConflict,
  IShowInfoImportConflictRes,
  IShowInfoImportResolution,
  IShowInfoPushConflictRes,
  IShowInfoPushResolution,
  ITranslationConflict,
  ITranslationConflictResolution,
} from "@evennt-tech/api-v2-external";

export {
  ShowInfoImportAction,
  ShowInfoPushAction,
} from "@evennt-tech/api-v2-external";

/**
 * A Show-level row inherits its content from the library when it carries a
 * master link. `ICategory` / `ITerm` declare those ids optional, since a library
 * master has none, so every read goes through these rather than `!!row.masterId`
 * scattered across components.
 */
export const isLinkedCategory = (category?: ICategory | null): boolean =>
  !!category?.masterCategoryId;

export const isLinkedTerm = (term?: ITerm | null): boolean =>
  !!term?.masterTermId;

export const getMasterTermId = (term?: ITerm | null): string | null =>
  term?.masterTermId ?? null;

export const getMasterCategoryId = (
  category?: ICategory | null
): string | null => category?.masterCategoryId ?? null;
